import { notificationTypes } from '@/helpers/enums';
import store from '@/store';

export const notificationOptions = {
	icon: '/logo.png',
	dir: 'rtl',
	lang: 'ar-SA',
};

export const notificationPageRedirect = [
	{ type: notificationTypes.message, redirect: '/chat', routeName: 'chat' },
	{ type: notificationTypes.attendance, redirect: '/attendance', routeName: 'attendance' },
	{ type: notificationTypes.newMark, redirect: '/grades', routeName: 'grades' },
	{ type: notificationTypes.newMarks, redirect: '/grades', routeName: 'grades' },
	{ type: notificationTypes.schedule, redirect: '/schedule', routeName: 'schedule' },
	{ type: notificationTypes.newTest, redirect: '/exams', routeName: 'exams' },
	{ type: notificationTypes.testsSchedule, redirect: '/exams', routeName: 'exams' },
	{ type: notificationTypes.transport, redirect: '/', routeName: 'home' },
	{ type: notificationTypes.notes, redirect: '/behavior', routeName: 'behavior' },
];

export const firebase = {
	configs: {
		apiKey: 'AIzaSyBUk-nmY07MlzuFjgMHPVG7Zfeo85uKdVE',
		authDomain: 'alawal-institute.firebaseapp.com',
		projectId: 'alawal-institute',
		storageBucket: 'alawal-institute.appspot.com',
		messagingSenderId: '82186538648',
		appId: '1:82186538648:web:25fb72333a089d2c2b0aed'
	},
	publicKey: 'BMUqrbPSUBlaXu8gSeh-tbQ_Bh0EHy2-R5pJpYYXvF5G0Y8q4uwl8STNMqaIlJQ1Sr6P_2l7iRDe3agMVnobdp8',
};

export const onGetNotification = () => {
	store.dispatch('notification/fetchAll');
};
